import { espBufFillRect, espBufFillRectTri, espBufHLine } from "./chunk-1.jsx";
export function espBufFillEllipseCorner(buf, w, h, corner, x0, y0, rx, ry, v) {
  if (rx < 2) return;
  if (ry < 2) return;
  let x;
  let y;
  let s;
  const rx2 = rx * rx;
  const ry2 = ry * ry;
  const fx2 = 4 * rx2;
  const fy2 = 4 * ry2;
  if (corner === 'T_R') {
    for (x = 0, y = ry, s = 2 * ry2 + rx2 * (1 - 2 * ry); ry2 * x <= rx2 * y; x++) {
      espBufHLine(buf, w, h, x0, y0 - y, x, v);
      if (s >= 0) {
        s += fx2 * (1 - y);
        y--;
      }
      s += ry2 * 4 * x + 6 * ry2;
    }
    for (x = rx, y = 0, s = 2 * rx2 + ry2 * (1 - 2 * rx); rx2 * y <= ry2 * x; y++) {
      espBufHLine(buf, w, h, x0, y0 - y, x, v);
      if (s >= 0) {
        s += fy2 * (1 - x);
        x--;
      }
      s += rx2 * 4 * y + 6 * rx2;
    }
    return;
  }
  if (corner === 'B_R') {
    for (x = 0, y = ry, s = 2 * ry2 + rx2 * (1 - 2 * ry); ry2 * x <= rx2 * y; x++) {
      espBufHLine(buf, w, h, x0, y0 + y - 1, x, v);
      if (s >= 0) {
        s += fx2 * (1 - y);
        y--;
      }
      s += ry2 * 4 * x + 6 * ry2;
    }
    for (x = rx, y = 0, s = 2 * rx2 + ry2 * (1 - 2 * rx); rx2 * y <= ry2 * x; y++) {
      espBufHLine(buf, w, h, x0, y0 + y - 1, x, v);
      if (s >= 0) {
        s += fy2 * (1 - x);
        x--;
      }
      s += rx2 * 4 * y + 6 * rx2;
    }
    return;
  }
  if (corner === 'T_L') {
    for (x = 0, y = ry, s = 2 * ry2 + rx2 * (1 - 2 * ry); ry2 * x <= rx2 * y; x++) {
      espBufHLine(buf, w, h, x0 - x, y0 - y, x, v);
      if (s >= 0) {
        s += fx2 * (1 - y);
        y--;
      }
      s += ry2 * 4 * x + 6 * ry2;
    }
    for (x = rx, y = 0, s = 2 * rx2 + ry2 * (1 - 2 * rx); rx2 * y <= ry2 * x; y++) {
      espBufHLine(buf, w, h, x0 - x, y0 - y, x, v);
      if (s >= 0) {
        s += fy2 * (1 - x);
        x--;
      }
      s += rx2 * 4 * y + 6 * rx2;
    }
    return;
  }
  if (corner === 'B_L') {
    for (x = 0, y = ry, s = 2 * ry2 + rx2 * (1 - 2 * ry); ry2 * x <= rx2 * y; x++) {
      espBufHLine(buf, w, h, x0 - x, y0 + y - 1, x, v);
      if (s >= 0) {
        s += fx2 * (1 - y);
        y--;
      }
      s += ry2 * 4 * x + 6 * ry2;
    }
    for (x = rx, y = 0, s = 2 * rx2 + ry2 * (1 - 2 * rx); rx2 * y <= ry2 * x; y++) {
      espBufHLine(buf, w, h, x0 - x, y0 + y, x, v);
      if (s >= 0) {
        s += fy2 * (1 - x);
        x--;
      }
      s += rx2 * 4 * y + 6 * rx2;
    }
  }
}
export function drawEspEye(buf, w, h, centerX, centerY, cfg) {
  const height = cfg.Height;
  const width = cfg.Width;
  const offX = cfg.OffsetX;
  const offY = cfg.OffsetY;
  const slopeTop = cfg.Slope_Top;
  const slopeBottom = cfg.Slope_Bottom;
  let rt = cfg.Radius_Top;
  let rb = cfg.Radius_Bottom;

  // EyeDrawer::Draw (pixel/box based)
  const deltaYTop = Math.trunc(height * slopeTop / 2.0);
  const deltaYBottom = Math.trunc(height * slopeBottom / 2.0);
  const totalHeight = height + deltaYTop - deltaYBottom;
  if (rb > 0 && rt > 0 && totalHeight - 1 < rb + rt) {
    const k = (totalHeight - 1) / (rb + rt);
    rt = Math.trunc(rt * k);
    rb = Math.trunc(rb * k);
  }
  const halfH = Math.trunc(height / 2);
  const halfW = Math.trunc(width / 2);
  const TLc_y = centerY + offY - halfH + rt - deltaYTop;
  const TLc_x = centerX + offX - halfW + rt;
  const TRc_y = centerY + offY - halfH + rt + deltaYTop;
  const TRc_x = centerX + offX + halfW - rt;
  const BLc_y = centerY + offY + halfH - rb - deltaYBottom;
  const BLc_x = centerX + offX - halfW + rb;
  const BRc_y = centerY + offY + halfH - rb + deltaYBottom;
  const BRc_x = centerX + offX + halfW - rb;
  const min_c_x = Math.min(TLc_x, BLc_x);
  const max_c_x = Math.max(TRc_x, BRc_x);
  const min_c_y = Math.min(TLc_y, TRc_y);
  const max_c_y = Math.max(BLc_y, BRc_y);

  // Fill eye centre
  espBufFillRect(buf, w, h, min_c_x, min_c_y, max_c_x, max_c_y, 1);

  // Fill outwards to meet edges of rounded corners
  espBufFillRect(buf, w, h, TRc_x, TRc_y, BRc_x + rb, BRc_y, 1); // Right
  espBufFillRect(buf, w, h, TLc_x - rt, TLc_y, BLc_x, BLc_y, 1); // Left
  espBufFillRect(buf, w, h, TLc_x, TLc_y - rt, TRc_x, TRc_y, 1); // Top
  espBufFillRect(buf, w, h, BLc_x, BLc_y, BRc_x, BRc_y + rb, 1); // Bottom

  // Slanted edges at top/bottom of eyes
  if (slopeTop > 0) {
    espBufFillRectTri(buf, w, h, TLc_x, TLc_y - rt, TRc_x, TRc_y - rt, 0);
    espBufFillRectTri(buf, w, h, TRc_x, TRc_y - rt, TLc_x, TLc_y - rt, 1);
  } else if (slopeTop < 0) {
    espBufFillRectTri(buf, w, h, TRc_x, TRc_y - rt, TLc_x, TLc_y - rt, 0);
    espBufFillRectTri(buf, w, h, TLc_x, TLc_y - rt, TRc_x, TRc_y - rt, 1);
  }
  if (slopeBottom > 0) {
    espBufFillRectTri(buf, w, h, BRc_x + rb, BRc_y + rb, BLc_x - rb, BLc_y + rb, 0);
    espBufFillRectTri(buf, w, h, BLc_x - rb, BLc_y + rb, BRc_x + rb, BRc_y + rb, 1);
  } else if (slopeBottom < 0) {
    espBufFillRectTri(buf, w, h, BLc_x - rb, BLc_y + rb, BRc_x + rb, BRc_y + rb, 0);
    espBufFillRectTri(buf, w, h, BRc_x + rb, BRc_y + rb, BLc_x - rb, BLc_y + rb, 1);
  }

  // Rounded corners
  if (rt > 0) {
    espBufFillEllipseCorner(buf, w, h, 'T_L', TLc_x, TLc_y, rt, rt, 1);
    espBufFillEllipseCorner(buf, w, h, 'T_R', TRc_x, TRc_y, rt, rt, 1);
  }
  if (rb > 0) {
    espBufFillEllipseCorner(buf, w, h, 'B_L', BLc_x, BLc_y, rb, rb, 1);
    espBufFillEllipseCorner(buf, w, h, 'B_R', BRc_x, BRc_y, rb, rb, 1);
  }
}
